import { render, staticRenderFns } from "./ApplicantSplitPages.vue?vue&type=template&id=236c7fb5&scoped=true&"
import script from "./ApplicantSplitPages.vue?vue&type=script&lang=js&"
export * from "./ApplicantSplitPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236c7fb5",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VRow,VSnackbar,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('236c7fb5')) {
      api.createRecord('236c7fb5', component.options)
    } else {
      api.reload('236c7fb5', component.options)
    }
    module.hot.accept("./ApplicantSplitPages.vue?vue&type=template&id=236c7fb5&scoped=true&", function () {
      api.rerender('236c7fb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploads/components/Media/ApplicantSplitPages.vue"
export default component.exports